<template>
  <div class="form-group checkbox-group">
    <label>Offerings</label>
    <modal-help>
      Choose at least one offering to give this rep access. To remove permissions, uncheck the offering(s) and then click on Confirm.
    </modal-help>
    <div class="checkbox-item checkbox checkbox-primary" v-for="offering in offerings">
      <input type="checkbox" name="offering-list" :value="offering.id" v-model="selectedOfferings" @change="selectCheckbox"/>
      <label>{{ offering.name }}</label>
    </div>
  </div>
</template>

<script>

import ModalHelp from "./ModalHelp";
export default {
  name: "OfferingList",
  components: {ModalHelp},
  props: {
    offerings: {
      type: Array,
      default: []
    },
    adminOfferings: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      selectedOfferings: []
    }
  },
  methods: {
    selectCheckbox: function(event) {
      this.$emit('checkbox',this.selectedOfferings)
    }
  },
  mounted() {
    if(this.adminOfferings.length > 0) {
      this.selectedOfferings = this.adminOfferings.slice(0)
    }
  }
}
</script>